import { Ref, useImperativeHandle } from "react";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { useTranslation } from "@coworker/locales";
import TaskInfoPanel from "@coworker/apprestructured/src/task-management/components/TaskInfoPanel/TaskInfoPanel";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";
import LoadingCreatorFragment from "@coworker/apprestructured/src/task-management/components/LoadingCreatorFragment/LoadingCreatorFragment";

export type TaskInfoPanelCreatorFragmentConfigProps = {
  // Translation key for the label
  label: string;
  // Field path in task data for the sublabel
  sublabelField?: string;
  // Field path in task data for the numeric value
  valueField: string;
  // Field path in task data for the caption
  captionField?: string;
};

type TaskInfoPanelCreatorFragmentProps = {
  configProps: TaskInfoPanelCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function TaskInfoPanelCreatorFragment({
  configProps,
  commonProps,
  ref,
}: TaskInfoPanelCreatorFragmentProps) {
  const { label, sublabelField, valueField, captionField } = configProps;
  const { task } = commonProps;

  const value = getTypedValue<number>(getByPath(task, valueField));
  const sublabel = sublabelField
    ? getTypedValue<string>(getByPath(task, sublabelField))
    : undefined;
  const caption = captionField
    ? getTypedValue<string>(getByPath(task, captionField))
    : undefined;

  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    valid: true,
  }));

  if (isLoading(value)) {
    return <LoadingCreatorFragment />;
  }

  return (
    <TaskInfoPanel
      label={t(label)}
      sublabel={sublabel && !isLoading(sublabel) ? sublabel : ""}
      value={value}
      caption={caption && !isLoading(caption) ? caption : ""}
    />
  );
}

export default TaskInfoPanelCreatorFragment;
